angular.module('CarsSaraBo').directive('map', function() {
  return {
    restrict: 'E',
    replace: true,
    template: '<div></div>',
    link: function (scope, element, attrs) {
        if (window.google && window.google.maps) {
            var map_options = {
                center: new google.maps.LatLng(40.294163, -3.7581804000000147),
                zoom: 8,
                streetViewControl: false,
                mapTypeControl: false,
                panControl: false,
                scaleControl: false,
                navigationControl: false,
                disableDoubleClickZoom: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 8,
                maxZoom: 15
            };

            var map = new google.maps.Map(element[0], map_options);

            var noPoi = [
                {
                    featureType: "poi",
                    stylers: [
                        { visibility: "off" }
                    ]
                }
            ];

            map.setOptions({styles: noPoi});
            scope.map = map;
        }
    }
  };
})


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/map_directive.js
// module id = 878
// module chunks = 3